import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import {EEToolContextProvider} from '../../../features/common/ee-tool/contexts/eeToolContext';
import {EEToolForm} from "../../../features/common/ee-tool/components/EEToolForm";
import {EEToolAdapterContextProvider} from "../../../features/common/ee-tool/contexts/eeToolAdapterContext";
import Toolbar from "devextreme-react/toolbar";
import {ToolbarItem} from "devextreme-react/popup";
import EstimateExitButton from "../../../features/common/ee-tool/components/EstimateExitButton";
import {Button} from "devextreme-react/button";

export default function EasyEstimatorToolPage() {

    const pageTitle = useTitle();
    useEffect(() => {
        pageTitle.setTitle('Easy Estimator')
    }, [pageTitle]);

    return (
        <EEToolContextProvider>
            <div className={'content-block'}>
                <EEToolAdapterContextProvider>
                    <EEToolForm/>
                </EEToolAdapterContextProvider>
            </div>
        </EEToolContextProvider>
    )
} 
